import { render, staticRenderFns } from "./configuration.vue?vue&type=template&id=357e8f83&scoped=true"
import script from "./configuration.vue?vue&type=script&lang=js"
export * from "./configuration.vue?vue&type=script&lang=js"
import style0 from "./configuration.vue?vue&type=style&index=0&id=357e8f83&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357e8f83",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/050/050admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('357e8f83')) {
      api.createRecord('357e8f83', component.options)
    } else {
      api.reload('357e8f83', component.options)
    }
    module.hot.accept("./configuration.vue?vue&type=template&id=357e8f83&scoped=true", function () {
      api.rerender('357e8f83', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/config/configuration.vue"
export default component.exports